import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'

export const StyledCardItem = styled.div`
  background: ${(props) => (props.ended ? 'transparent' : 'transparent')};
  border: 1px solid #c9c8c7;
  border-radius: 6px;
  min-height: 250px;
  padding: 20px 30px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  animation: appear 1s forwards;
  transition: all 500ms ease;
  &:hover {
    p, small, button, svg {
      filter: brightness(1.5);
    }
  }

  .flex-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .left {
    width: 100%;
  }

  .cardContent {
    color: #fff;
    p {
      margin: 4px 0;
      font-size: 87%;
    }
    .speakerBtn {
      cursor: pointer;
    }
  }
  .session-title {
    color: #B4173A;
    /* color: #d22dc9; */
    margin-bottom: 8px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.3;
  }

  .cardAction {
    color: #2c2738;

    .iconContainer {
      display: flex;
      align-items: flex-start;
      padding: 4px 10px;
      svg {
        width: 24px;
      }
      p {
        font-size: 70%;
        margin-top: 6px;
        margin-left: 4px;
        font-weight: 400;
      }
      .liveState {
        font-size: 20px;
        margin-top: -1px;
        margin-left: 16px;
        font-weight: 800;
        animation: heartbeat 1s infinite;
      }
    }
  }
  .speaker-profile {
    color: #505c7c;
    display: flex;
    margin-bottom: 8px;
    cursor: pointer;

    &:hover {
      .avatar {
        transform: scale(1.1);
      }
    }
  }
  .avatar {
    width: 45px;
    height: 45px;
    margin-right: 8px;
  }
  .speaker-name {
    font-weight: 600;
    color: #0880AE;
    filter: brightness(1.5);
  }
  .upgrade {
    color: #3807c7;
    font-weight: 600;
    font-size: 9px;
    cursor: pointer;
    &.replay {
      font-size: 11px;
      color: #505c7c;
    }
  }
  .join-button {
    color: white;
    border: 1px solid #B4173A;
    background-color: #B4173A;
    padding: 0;
    display: block;
    width: 100%;
    margin: auto;
    &:hover {
      text-decoration: none !important;
    }

    span {
      background: #B4173A;
      display: block;
      margin: 2px;
      padding: 4px 8px;
      font-size: 80%;
      font-weight: 500;
    }
  }
  .activeJoin {
    /* animation: heartbeat 5s infinite; */
  }
  .disabled {
    border: 1px solid #c9c8c7;
    span {
      background: #c9c8c7;
    }
  }
  .btn-disabled {
    border: 1px solid #505c7c;
    span {
      background: #505c7c;
    }
  }
  // Add to calendar library
  .chq-atc {
    font-size: 0.9em;
    small {
      color: $primary;
      line-height: 1;
    }
    svg path {
      fill: $primary;
    }
    button {
      display: flex;
      align-items: center;
    }
  }
  
  ${SIZES.mobile} {
    padding: 20px;
    flex-direction: column;
    .left {
      width: 100%;
      footer {
        margin: 12px 0;
        .speaker-profile {
          img {
            width: 55px;
            height: 55px;
          }
        }
      }
    }
    .right {
      flex-direction: row;
      align-items: flex-end;
    }
  }
`

export const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 24px;
    border: none;
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  }

  .presenter-name {
    color: #0880AE;
    text-align: center;
  }
  .presenter-title {
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    p {
      margin: 0;
    }
  }
  .close-btn {
    cursor: pointer;
    height: 40px;
    width: 40px;
    margin-bottom: -12px;
  }
  .desc-text {
    font-size: 14px;
  }
  .modal-body {
    padding: 1rem 2rem;
    color: #2f2f2f;
    h5 {
      font-weight: 600;
    }
  }
`